"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", [_c("a-button", _vm._b({
    on: {
      click: function ($event) {
        _vm.visible = true;
      }
    }
  }, "a-button", _vm._.merge({
    icon: "sync",
    type: "primary"
  }, _vm.btnProps), false), [_vm._v(_vm._s(_vm.btnTitle))]), _c("BasisModal", {
    attrs: {
      "after-close": _vm.afterClose,
      "confirm-loading": _vm.confirmLoading,
      title: _vm.modalTitle || _vm.btnTitle
    },
    on: {
      ok: _vm.handleOk
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("a-form-model", {
    ref: "form",
    attrs: {
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      },
      model: _vm.form,
      rules: _vm.rules,
      layout: "horizontal"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.dateLabel,
      prop: "rangeDate"
    },
    scopedSlots: _vm._u([{
      key: "extra",
      fn: function () {
        return [_vm._v(_vm._s(_vm.dateDesc ? _vm.dateDesc : _vm.dateSpan === 0 ? "" : `注：只能选择最近${_vm.dateSpan}天之内${_vm.dateSpan === _vm.dateRange ? "" : "，开始时间和结束时间的间隔不能超过" + _vm.dateRange + "天"}`))];
      },
      proxy: true
    }])
  }, [_c("a-range-picker", _vm._b({
    attrs: {
      "disabled-date": _vm.disabledDate
    },
    model: {
      value: _vm.form.rangeDate,
      callback: function ($$v) {
        _vm.$set(_vm.form, "rangeDate", $$v);
      },
      expression: "form.rangeDate"
    }
  }, "a-range-picker", _vm.rangePickerProps, false))], 1), _vm.needShopNo ? _c("a-form-model-item", {
    attrs: {
      label: "选择店铺",
      prop: "shopNo"
    },
    scopedSlots: _vm._u([{
      key: "extra",
      fn: function () {
        return [_vm._v(_vm._s(_vm.shopDesc))];
      },
      proxy: true
    }], null, false, 2557422079)
  }, [_c("BasisShopLevelTreeSelect", _vm._b({
    on: {
      change: ({
        shopNos
      }) => _vm.form.shopNo = shopNos.toString()
    },
    model: {
      value: _vm.selectedLevel,
      callback: function ($$v) {
        _vm.selectedLevel = $$v;
      },
      expression: "selectedLevel"
    }
  }, "BasisShopLevelTreeSelect", _vm.shopLevelProps, false))], 1) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;